import { phaseDeg, unwrapPhaseDeg } from '../math/phase.js';
import { createGridPass } from '../regl/grid-pass.js';
import { createLinePass } from '../regl/line-pass.js';
import { createReglContext } from '../regl/setup.js';
import { drawRectangularAtop } from './rectangular.js';
export const phaseRenderer = {
    kind: 'phase',
    displayName: 'Phase',
    mount(canvas) {
        const ctx = createReglContext(canvas);
        const linePass = createLinePass(ctx);
        const gridPass = createGridPass(ctx);
        const instance = {
            resize(width, height, dpr) {
                ctx.resizeToCss(width, height, dpr);
            },
            draw(frame, traces, format, theme) {
                const opts = format.phase ?? { unwrap: false, units: 'deg', xScale: 'linear' };
                const toY = (samples) => {
                    const raw = samples.map(phaseDeg);
                    const result = opts.unwrap ? unwrapPhaseDeg(raw) : raw;
                    if (opts.units === 'rad') {
                        return [...result].map((d) => (d * Math.PI) / 180);
                    }
                    return result;
                };
                drawRectangularAtop(ctx, linePass, gridPass, frame, traces, toY, 'phase', format, opts.xScale, format.overlayFrames, theme);
            },
            destroy() {
                linePass.destroy();
                gridPass.destroy();
                ctx.destroy();
            },
        };
        return instance;
    },
};
//# sourceMappingURL=phase.js.map